import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { DepartmentDetailResponse } from 'api';
import { WorkFormCompanyInfo, WorkFormContext } from '../work-form.types';

export const useWorkFormDefaults = (
  defaultValues: Partial<WorkFormContext> | undefined,
  selectedCompany: WorkFormCompanyInfo | undefined,
  departmentData: DepartmentDetailResponse | undefined,
  setValue: UseFormSetValue<WorkFormContext>
) => {
  useEffect(() => {
    if (defaultValues) {
      if (defaultValues.companyOption) {
        setValue('companyOption', defaultValues.companyOption);
      }
      if (defaultValues.jobId) {
        setValue('jobId', defaultValues.jobId);
      }
      setValue('department', defaultValues.department);
      setValue('startDate', defaultValues.startDate);
      setValue('endDate', defaultValues.endDate);
      setValue('startTime', defaultValues.startTime);
      setValue('endTime', defaultValues.endTime);
      setValue('breakMinutes', defaultValues.breakMinutes);
      setValue('maxClaimants', defaultValues.maxClaimants);
      setValue('hourlyRate', defaultValues.hourlyRate);
      setValue('mutableUntilHours', defaultValues.mutableUntilHours);
      setValue('cla', defaultValues.cla);
      setValue('jobType', defaultValues.jobType);
      setValue('location', defaultValues.location, { shouldValidate: true });
      setValue('contactName', defaultValues.contactName);
      setValue('contactPhoneWithPrefix', defaultValues.contactPhoneWithPrefix);
      setValue('imageUrl', defaultValues.imageUrl);
      setValue('vat', defaultValues.vat);
      setValue('isFlexPoolOnly', defaultValues.isFlexPoolOnly);
      setValue('shortDescription', defaultValues.shortDescription);
      setValue('longDescription', defaultValues.longDescription);
      setValue('descriptionLegalRequirements', defaultValues.descriptionLegalRequirements);
      setValue('jobCertificates', defaultValues.jobCertificates);
      setValue('isFreelanceOrtApplicable', defaultValues.isFreelanceOrtApplicable);
      setValue('isTempworkOrtApplicable', defaultValues.isTempworkOrtApplicable);
    }
  }, [
    defaultValues?.companyOption,
    defaultValues?.jobId,
    defaultValues?.department,
    defaultValues?.breakMinutes,
    defaultValues?.hourlyRate,
    defaultValues?.mutableUntilHours,
    defaultValues?.cla,
    defaultValues?.jobType,
    defaultValues?.location,
    defaultValues?.contactName,
    defaultValues?.contactPhoneWithPrefix,
    defaultValues?.vat,
    defaultValues?.flexPools,
    defaultValues?.isFlexPoolOnly,
    defaultValues?.shortDescription,
    defaultValues?.longDescription,
    defaultValues?.descriptionLegalRequirements,
    defaultValues?.jobCertificates,
    defaultValues?.imageUrl,
    defaultValues?.isFreelanceOrtApplicable,
    defaultValues?.isTempworkOrtApplicable,
  ]);

  useEffect(() => {
    if (defaultValues == null || selectedCompany == null) {
      return;
    }
    setValue('isFreelance', defaultValues.isFreelance && selectedCompany.offersFreelanceWork);
    setValue('isTempwork', defaultValues.isTempwork && selectedCompany.offersTempWork);
    setValue('isEmployee', defaultValues.isEmployee && selectedCompany.offersEmployeeWork);
  }, [
    defaultValues?.isFreelance,
    defaultValues?.isTempwork,
    defaultValues?.isEmployee,
    selectedCompany,
  ]);

  useEffect(() => {
    const departmentFlexPools = departmentData?.department?.flexPools ?? [];
    const assignedFlexPools = defaultValues?.flexPools ?? [];

    const flexPools = assignedFlexPools.filter((assigned) =>
      departmentFlexPools.some((option) => option.id === assigned.id)
    );

    setValue('flexPools', flexPools);
  }, [defaultValues?.flexPools, departmentData?.department.flexPools]);
};
